import { DateOnly } from '@if/core/date'
import { ControlledDateOnlyPicker } from '@if/mui'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

interface UpdateExpirationDateDialogProps {
  open: boolean
  expirationDate: DateOnly | null
  onClose: () => void
  onUpdate: (date: DateOnly | null) => void
}

const UpdateExpirationDateDialog: React.FC<UpdateExpirationDateDialogProps> = ({
  open,
  expirationDate,
  onClose,
  onUpdate,
}) => {
  const { t } = useTranslation()

  const { control, handleSubmit, reset } = useForm<{ expiration: DateOnly | null }>()

  useEffect(() => {
    reset({ expiration: expirationDate })
  }, [expirationDate, reset])

  const onSubmit = handleSubmit((data) => {
    onUpdate(data.expiration)
    onClose()
  })

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t('banishments.expirationDate.title')}</DialogTitle>
      <DialogContent>
        <ControlledDateOnlyPicker
          name="expiration"
          control={control}
          label={t('banishments.expirationDate.label')}
          sx={{ marginTop: 2, width: '100%' }}
        />
        <div style={{ marginTop: 8, marginBottom: 4, fontSize: '0.75rem' }}>
          {t('banishments.expirationDate.helperText')}
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('common.cancel')}</Button>
        <Button onClick={onSubmit} variant="contained" color="primary">
          {t('common.save')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default UpdateExpirationDateDialog
